import {
  configApiRef,
  createApiFactory,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { scmAuthApiRef } from '@backstage/integration-react';
import { githubApiRef, GithubClient } from './api';
import { rootRouteRef } from './routes';

export const emisxReleasesPlugin = createPlugin({
  id: 'emisx-releases',
  apis: [
    createApiFactory({
      api: githubApiRef,
      deps: { configApi: configApiRef, scmAuthApi: scmAuthApiRef },
      factory: ({ configApi, scmAuthApi }) =>
        new GithubClient({ configApi, scmAuthApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const EmisxReleasesPage = emisxReleasesPlugin.provide(
  createRoutableExtension({
    name: 'EmisxReleasesPage',
    component: () => import('./components/Releases').then(m => m.Releases),
    mountPoint: rootRouteRef,
  }),
);
